// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"7f4318d3","106":"e57d08d8","163":"02a56837","322":"f1d7b600","326":"5b0040a9","385":"70bfb19f","408":"15268b35","488":"0818279b","713":"11b2f54a","882":"d688fe94","982":"25d88633"}[chunkId] + ".chunk.js";
};